
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class ProductsDescriptionTextField extends Vue {
  @Prop(String) public value: string;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  get fieldValue() {
    return this.value;
  }

  set fieldValue(value) {
    this.$emit('input', value || '');
  }
}
